import {ImageBlockType, ImageType} from 'campagne/types'

import {Block} from '../blocks'
import {Picture} from '@codeurs/front'
import React from 'react'
import {style} from 'util/campagne/style'

const styles = style('imageblock')

const ImageBlock: React.FC<ImageBlockType> = ({image: images}) => (
	<Block class={styles}>
		{images.map((image: ImageType, index: number) => {
			if (!image) return null
			return (
				<Picture
					key={index}
					src={image.src}
					width={image.width}
					height={image.height}
					focus={image.focus}
					alt={image.alt}
				/>
			)
		})}
	</Block>
)
export default ImageBlock
